<div class="my-4 w-full">
  <ul class="flex flex-row flex-wrap text-lg font-medium">
    @for (breadcrumb of (breadcrumbs$ | async); track breadcrumb.uid; let last = $last; let first = $first) {
      @if (first && !last) {
        <a [routerLink]="breadcrumb.url">
          <li><i class="fa-solid fa-house"></i></li>
        </a>
      }
      @if (first && last) {
        <li><i class="fa-solid fa-house"></i></li>
      }

      @if (!first && last) {
        <li >{{breadcrumb.label | translate}}</li>
      }
      @if (!first && !last) {
        <li class="primary" [routerLink]="breadcrumb.url"style="cursor: pointer;">{{breadcrumb.label | translate}}</li>
      }
    }
  </ul>
</div>
